export enum ExternalPaymentStatus {
    Pending = 0,
    Paid = 1,
    Refunded = 2,
    Settled = 3
}
